import { CLOSE_SIDEPANEL, SET_SIDEPANEL, REVERT_SIDEPANEL } from './actions';

const initialState = {
  displaySidePanel: false,
  id: null,
  entity: null,
  state: null,
  breadcrumbs: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIDEPANEL:
    case REVERT_SIDEPANEL:
      return {
        ...action.data,
        displaySidePanel: true
      };
    case CLOSE_SIDEPANEL:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
